import PropTypes from "prop-types";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const AddListItem = ({ onClick, children }) => (
  <li className="border-input bg-primary hover:border-secondary group flex h-10 cursor-pointer select-none items-center justify-between rounded-md border border-dashed px-3 transition-colors">
    <button type="submit" className="h-full w-full" onClick={onClick}>
      <div className="flex gap-2">
        <Icon type="16-add" size={16} useWithFillCurrentColor />
        <Typography.LabelSm weight="medium">{children}</Typography.LabelSm>
      </div>
    </button>
  </li>
);

AddListItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};
